import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { certificateModalQueriesKeys } from '../constants'

/**
 * Fetches a client key for BIG Project..
 * @param {Object} options - Additional options for the query.
 * @returns {Object} - Downloads the cert key
 */

export const useGetFileMtlsClientQuery = (options) => {
  const handleQuery = async () => {
    const config = {
      method: 'get',
      responseType: 'blob'
    }

    const { data } = await api(`/api/v2/object-store/mtls/client.p12`, config)

    return data
  }

  return useQuery({
    queryKey: [certificateModalQueriesKeys.GET_MTLS_CLIENT_KEY],
    queryFn: handleQuery,
    ...options
  })
}
